var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 18.8335C15.0503 18.8335 18.3335 15.5503 18.3335 11.5002C18.3335 7.45007 15.0503 4.16683 11.0002 4.16683C6.95007 4.16683 3.66683 7.45007 3.66683 11.5002C3.66683 15.5503 6.95007 18.8335 11.0002 18.8335ZM11.0002 20.6668C16.0628 20.6668 20.1668 16.5628 20.1668 11.5002C20.1668 6.43755 16.0628 2.3335 11.0002 2.3335C5.93755 2.3335 1.8335 6.43755 1.8335 11.5002C1.8335 16.5628 5.93755 20.6668 11.0002 20.6668Z",
    fill: "#CACCD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 6C11.5064 6 11.9168 6.41041 11.9168 6.91667V11.1203L13.94 13.1435C14.298 13.5015 14.298 14.0819 13.94 14.4398C13.582 14.7978 13.0016 14.7978 12.6436 14.4398L10.352 12.1482C10.1801 11.9763 10.0835 11.7431 10.0835 11.5V6.91667C10.0835 6.41041 10.4939 6 11.0002 6Z",
    fill: "#CACCD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.270b5ba7.svg";
export { ForwardRef as ReactComponent };